import gql from 'graphql-tag';

export default {
  Merchant: {
    GET_LIST: gql`
      query AllMerchants(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: MerchantFilter
      ) {
        items: allMerchants(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          brc_number
          name
          type
          country
          brand
          industry
          status
          employeeID
          mdrID
          created_at
          updated_at
          brc_image_path
          apollo_backuser_approved_merchant {
            id
            username
            phone
            fullname
            role
            status
            authentype
            created_at
            updated_at
          }
          apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
            apollo_employee {
              id
              username
              fullname
              phone
              email
              address
              role
              status
              authentype
              submerchantID
              created_at
              updated_at
            }
          }
        }
        total: _allMerchantsMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query Merchant($id: Int!) {
        data: Merchant(id: $id) {
          id
          brc_number
          name
          type
          country
          brand
          industry
          status
          employeeID
          mdrID
          created_at
          updated_at
          brc_image_path
          apollo_backuser_approved_merchant {
            id
            username
            phone
            fullname
            role
            status
            authentype
            created_at
            updated_at
          }
          apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
            apollo_employee {
              id
              username
              fullname
              phone
              email
              address
              role
              status
              authentype
              submerchantID
              created_at
              updated_at
            }
          }
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateMerchant(
        $id: Int!
        $brand: String
        $brcNumber: String
        $country: Int
        $industry: String
        $name: String
        $status: Int
        $type: String
      ) {
        data: updateMerchant(
          id: $id
          brand: $brand
          brc_number: $brcNumber
          country: $country
          industry: $industry
          name: $name
          status: $status
          type: $type
        ) {
          id
          brc_number
          name
          type
          country
          brand
          industry
          status
          employeeID
          mdrID
          created_at
          updated_at
          brc_image_path
          apollo_backuser_approved_merchant {
            id
            username
            phone
            fullname
            role
            status
            authentype
            created_at
            updated_at
          }
          apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
            apollo_employee {
              id
              username
              fullname
              phone
              email
              address
              role
              status
              authentype
              submerchantID
              created_at
              updated_at
            }
          }
        }
      }
    `,
    CREATE: gql`
      mutation CreateMerchant(
        $brcNumber: String!
        $name: String!
        $type: String!
        $country: Int!
        $brand: String
        $industry: String
      ) {
        data: createMerchant(
          brc_number: $brcNumber
          name: $name
          type: $type
          country: $country
          brand: $brand
          industry: $industry
        ) {
          id
          brc_number
          name
          type
          country
          brand
          industry
          status
          employeeID
          mdrID
          created_at
          updated_at
          brc_image_path
        }
      }
    `,
    DELETE_ONE: gql`
      mutation DeleteMerchant($id: Int!) {
        data: deleteMerchant(id: $id) {
          id
          brc_number
          name
          type
          country
          brand
          industry
          status
          employeeID
          mdrID
          created_at
          updated_at
          brc_image_path
        }
      }
    `,
  },
  SubMerchant: {
    GET_LIST: gql`
      query AllSubMerchants(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: SubMerchantFilter
      ) {
        items: allSubMerchants(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          merchantID
          submerchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
          other_apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
          }
        }
        total: _allSubMerchantsMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query SubMerchant($id: Int!) {
        data: SubMerchant(id: $id) {
          id
          merchantID
          submerchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
          other_apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
          }
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateSubMerchant(
        $id: Int!
        $address: String
        $bankAccount: String
        $city: Int
        $email: String
        $merchantID: Int
        $name: String
        $phone: String
        $state: Int
        $submerchantID: Int
        $zip: String
      ) {
        data: updateSubMerchant(
          id: $id
          address: $address
          bank_account: $bankAccount
          city: $city
          email: $email
          merchantID: $merchantID
          name: $name
          phone: $phone
          state: $state
          submerchantID: $submerchantID
          zip: $zip
        ) {
          id
          merchantID
          submerchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
          other_apollo_submerchant {
            id
            merchantID
            submerchantID
            name
            zip
            state
            city
            phone
            email
            address
            bank_account
            status
            created_at
            updated_at
          }
        }
      }
    `,
    DELETE_ONE: gql`
      mutation DeleteSubMerchant($id: Int!) {
        data: deleteSubMerchant(id: $id) {
          id
          merchantID
          submerchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
        }
      }
    `,
    CREATE: gql`
      mutation CreateSubMerchant(
        $merchantID: Int!
        $phone: String!
        $email: String!
        $address: String!
        $submerchantID: Int
        $contractID: String
        $name: String
        $zip: String
        $state: String
        $city: String
        $bank_account: String
      ) {
        data: createSubMerchant(
          merchantID: $merchantID
          phone: $phone
          email: $email
          address: $address
          submerchantID: $submerchantID
          contractID: $contractID
          name: $name
          zip: $zip
          state: $state
          city: $city
          bank_account: $bank_account
        ) {
          id
          merchantID
          submerchantID
          name
          zip
          state
          city
          phone
          email
          address
          bank_account
          status
          created_at
          updated_at
        }
      }
    `,
  },
  Employee: {
    GET_LIST: gql`
      query AllEmployees(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: EmployeeFilter
      ) {
        items: allEmployees(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          submerchantID
          SubMerchant {
            id
            name
          }
          terminals {
            id
            alias
            terminal_code
          }
          created_at
          updated_at
        }
        total: _allEmployeesMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query Employee($id: Int) {
        data: Employee(id: $id) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          submerchantID
          SubMerchant {
            id
            name
          }
          terminals {
            id
            alias
            terminal_code
          }
          created_at
          updated_at
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateEmployee(
        $id: Int!
        $role: Int
        $address: String
        $email: String
        $fullname: String
        $phone: String
        $authentype: Int
        $terminalID: Int
        $submerchantID: Int
        $username: String
      ) {
        data: updateEmployee(
          id: $id
          role: $role
          address: $address
          email: $email
          fullname: $fullname
          phone: $phone
          authentype: $authentype
          terminalID: $terminalID
          submerchantID: $submerchantID
          username: $username
        ) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          submerchantID
          SubMerchant {
            id
            name
          }
          terminals {
            id
            alias
            terminal_code
          }
          created_at
          updated_at
        }
      }
    `,
    DELETE_ONE: gql`
      mutation DeleteEmployee($id: Int!) {
        data: deleteEmployee(id: $id) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          submerchantID
          created_at
          updated_at
        }
      }
    `,
    CREATE: gql`
      mutation DeleteEmployee(
        $email: String!
        $fullname: String!
        $phone: String!
        $username: String!
        $submerchantID: Int!
        $password: String
        $role: Int
        $address: String
      ) {
        data: createEmployee(
          email: $email
          fullname: $fullname
          phone: $phone
          username: $username
          submerchantID: $submerchantID
          password: $password
          role: $role
          address: $address
        ) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          submerchantID
          created_at
          updated_at
        }
      }
    `,
  },
  BackUser: {
    GET_LIST: gql`
      query AllBackUsers(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: BackUserFilter
      ) {
        items: allBackUsers(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          username
          phone
          fullname
          role
          status
          authentype
          created_at
          updated_at
        }
        total: _allBackUsersMeta(
          page: $page
          perPage: $perPage
          sortOrder: $sortOrder
          sortField: $sortField
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query BackUser($id: Int) {
        data: BackUser(id: $id) {
          id
          username
          phone
          fullname
          role
          status
          authentype
          created_at
          updated_at
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateBackUser(
        $id: Int!
        $phone: String
        $fullname: String
        $username: String
        $authentype: Int
      ) {
        data: updateBackUser(
          id: $id
          phone: $phone
          fullname: $fullname
          username: $username
          authentype: $authentype
        ) {
          id
          username
          phone
          fullname
          role
          status
          authentype
          created_at
          updated_at
        }
      }
    `,
    CREATE: gql`
      mutation CreateBackUser(
        $fullname: String!
        $username: String!
        $phone: String!
        $password: String
      ) {
        data: createBackUser(
          fullname: $fullname
          username: $username
          phone: $phone
          password: $password
        ) {
          id
          username
          phone
          fullname
          role
          status
          authentype
          created_at
          updated_at
        }
      }
    `,
    DELETE_ONE: gql`
      mutation DeleteBackUser($id: Int!) {
        data: deleteBackUser(id: $id) {
          id
          username
          phone
          fullname
          role
          status
          authentype
          created_at
          updated_at
        }
      }
    `,
  },
  Terminal: {
    GET_LIST: gql`
      query AllTerminals(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: TerminalFilter
      ) {
        items: allTerminals(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          submerchantID
          contractID
          terminal_code
          alias
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
        }
        total: _allTerminalsMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query Terminal($id: Int!) {
        data: Terminal(id: $id) {
          id
          submerchantID
          contractID
          terminal_code
          alias
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateTerminal(
        $id: Int!
        $submerchantID: Int
        $alias: String
        $apollo_employee: [ListId]
      ) {
        data: updateTerminal(
          id: $id
          submerchantID: $submerchantID
          alias: $alias
          apollo_employee: $apollo_employee
        ) {
          id
          submerchantID
          contractID
          terminal_code
          alias
          status
          created_at
          updated_at
          apollo_employee {
            id
          }
        }
      }
    `,
    DELETE_ONE: gql`
      mutation UpdateTerminal($id: Int!) {
        data: deleteTerminal(id: $id) {
          id
          submerchantID
          contractID
          terminal_code
          alias
          status
          created_at
          updated_at
        }
      }
    `,
    CREATE: gql`
      mutation CreateTerminal(
        $submerchantID: Int!
        $alias: String!
        $employeeIDs: [Int]
      ) {
        data: createTerminal(
          submerchantID: $submerchantID
          alias: $alias
          employeeIDs: $employeeIDs
        ) {
          id
          submerchantID
          contractID
          terminal_code
          alias
          status
          created_at
          updated_at
          apollo_employee {
            id
            username
            fullname
            phone
            email
            address
            role
            status
            authentype
            submerchantID
            created_at
            updated_at
          }
        }
      }
    `,
  },
  Category: {
    GET_LIST: gql`
      query AllCategories(
        $filter: CategoryFilter
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
      ) {
        items: allCategories(
          filter: $filter
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
        ) {
          id
          description
          name
          parentID
          status
          created_at
          created_by
          Category {
            id
            name
          }
          apollo_item {
            id
            name
            price
            quantity
            status
            attributes
            unit
            created_at
          }
          submerchant_created {
            id
            name
          }
          other_apollo_category {
            id
            name
            parentID
            status
            created_at
          }
          updated_at
        }
        total: _allCategoriesMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
    GET_ONE: gql`
      query Category($id: Int!) {
        data: Category(id: $id) {
          id
          description
          name
          parentID
          status
          created_at
          created_by
          Category {
            id
            name
          }
          apollo_item {
            id
            name
            price
            quantity
            status
            attributes
            unit
            created_at
          }
          submerchant_created {
            id
            name
          }
          other_apollo_category {
            id
            name
            parentID
            status
            created_at
          }
          updated_at
        }
      }
    `,
    CREATE: gql`
      mutation CreateCategory(
        $parentID: Int!
        $name: String!
        $description: String
        $submerchantIDs: [Int]!
      ) {
        data: createCategory(
          parentID: $parentID
          name: $name
          description: $description
          submerchantIDs: $submerchantIDs
        ) {
          id
          description
          name
          parentID
          status
          created_at
          created_by
          Category {
            id
            name
          }
          apollo_item {
            id
            name
            price
            quantity
            status
            attributes
            unit
            created_at
          }
          submerchant_created {
            id
            name
          }
          other_apollo_category {
            id
            name
            parentID
            status
            created_at
          }
          updated_at
        }
      }
    `,
    UPDATE: gql`
      mutation UpdateCategory(
        $description: String
        $id: Int!
        $parentID: Int
        $name: String
        $status: Int
      ) {
        data: updateCategory(
          description: $description
          id: $id
          parentID: $parentID
          name: $name
          status: $status
        ) {
          id
          description
          name
          parentID
          status
          created_at
          created_by
          Category {
            id
            name
          }
          apollo_item {
            id
            name
            price
            quantity
            status
            attributes
            unit
            created_at
          }
          submerchant_created {
            id
            name
          }
          other_apollo_category {
            id
            name
            parentID
            status
            created_at
          }
          updated_at
        }
      }
    `,
  },
  Item: {
    GET_LIST: gql`
      query AllItems(
        $page: Int
        $perPage: Int
        $sortField: String
        $sortOrder: String
        $filter: ItemFilter
      ) {
        items: allItems(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          id
          name
          price
          quantity
          status
          unit
          attributes
          categoryID
          created_at
          description
          updated_at
          updated_by
        }
        total: _allItemsMeta(
          page: $page
          perPage: $perPage
          sortField: $sortField
          sortOrder: $sortOrder
          filter: $filter
        ) {
          count
        }
      }
    `,
  },
  Bill: {
      GET_LIST: gql`
      query AllBills($page: Int, $perPage: Int, $sortField: String, $sortOrder: String, $filter: BillFilter) {
          items: allBills(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {
              id
              merchantID
              submerchantID
              employeeID
              terminalID
              transactionID
              code
              name
              price
              discount
              tax_fee
              description
              status
              tran_amount
              tran_account
              tran_date
              created_at
              updated_at
              apollo_bill_item {
                  id
                  billID
                  itemID
                  attributes
                  categoryID
                  name
                  description
                  price
                  quantity
                  status
                  created_at
                  updated_at
              }
          },
          total: _allBillsMeta(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {
              count
          }
      }
      `,
      GET_ONE: gql`
          query Bill($id: Int!) {
              data: Bill(id: $id) {
                  id
                  merchantID
                  submerchantID
                  employeeID
                  terminalID
                  transactionID
                  code
                  name
                  price
                  discount
                  tax_fee
                  description
                  status
                  tran_amount
                  tran_account
                  tran_date
                  created_at
                  updated_at
                  apollo_bill_item {
                      id
                      billID
                      itemID
                      categoryID
                      name
                      description
                      attributes
                      price
                      quantity
                      status
                      created_at
                      updated_at
                  }
              }
          }
      `,
      UPDATE: gql`
      mutation UpdateBill($id: Int!, $name: String, $price: Float, $discount: Float, $itemIDs: [ItemIdList]) {
          data: updateBill(id: $id, name: $name, price: $price, discount: $discount, itemIDs: $itemIDs) {
              id
              merchantID
              submerchantID
              employeeID
              terminalID
              transactionID
              code
              name
              price
              discount
              tax_fee
              description
              status
              tran_amount
              tran_account
              tran_date
              created_at
              updated_at
              apollo_bill_item {
                  id
                  billID
                  itemID
                  categoryID
                  name
                  description
                  attributes
                  price
                  quantity
                  status
                  created_at
                  updated_at
              }
          }
        }
      `,
      DELETE_ONE: gql`
          mutation DeleteBill($id: Int!) {
              data: deleteBill(id: $id) {
                  id
                  code
                  name
              }
          }
      `,
      CREATE: gql`
      mutation CreateBill($id: Int!, $name: String, $price: Float, $discount: Float, $itemIDs: [ItemIdList]) {
          data: createBill(id: $id, name: $name, price: $price, discount: $discount, itemIDs: $itemIDs) {
              id
              merchantID
              submerchantID
              employeeID
              terminalID
              transactionID
              code
              name
              price
              discount
              tax_fee
              description
              status
              tran_amount
              tran_account
              tran_date
              created_at
              updated_at
              apollo_bill_item {
                  id
                  billID
                  itemID
                  categoryID
                  name
                  description
                  attributes
                  price
                  quantity
                  status
                  created_at
                  updated_at
              }
          }
        }
      `
  }
};
